export default "__VITE_ASSET__Zpl4Qg1g__"